module.exports = __webpack_public_path__ + "f174b5891bd51932a81a4acd72eec7f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/StaticPage/ComeBack/assets/sec-4/carters.jpg
// module id = ./app/containers/StaticPage/ComeBack/assets/sec-4/carters.jpg
// module chunks = 40